export const CREATE_CQCLOCATIONS = "CREATE_CQCLOCATIONS";   
export const RETRIEVE_CQCLOCATIONS = "RETRIEVE_CQCLOCATIONS";
export const RETRIEVESINGLE_CQCLOCATIONS = "RETRIEVESINGLE_CQCLOCATIONS";
export const UPDATE_CQCLOCATIONS = "UPDATE_CQCLOCATIONS";   
export const DELETE_CQCLOCATIONS = "DELETE_CQCLOCATIONS"; 